import powerConsumption from '../../assets/icon/PowerConsumption.png'
import carbonFootPrint from '../../assets/icon/carbon.png'
import temperature from '../../assets/icon/charts/temperature.svg'
import onTime from '../../assets/icon/powerIcon.png'

import voltage from '../../assets/icon/voltage.png'
import powerFactor from '../../assets/icon/powerFactor.png'
import deviceStatus from '../../assets/icon/DeviceStatus.png'
import ac from '../../assets/icon/ac.png'
// Energy meter with a kWh readout; every units tile and chart uses it.
import unitConsumed from '../../assets/icon/charts/units.svg'
import moneySpent from '../../assets/icon/moneySpent.png'
import moneySaved from '../../assets/icon/moneySaved.png'
import applianceHealth from '../../assets/icon/ApplinaceHealth.png'
import savingPercantage from '../../assets/icon/saving.png'
import unit from '../../assets/icon/unit.png'
import coin from '../../assets/icon/coin.png'
import blub from '../../assets/icon/bulb.png'
import geyser from '../../assets/icon/geyser.png'
import smartService from '../../assets/icon/smartService.png'
import centerBanner from '../../assets/login/loginBanner.webp'
import bottomBanner from '../../assets/login/bottomBanner.png'
import doorOpen from '../../assets/icon/doorOpen.png'
import doorClose from '../../assets/icon/doorClose.png'
import calendar from '../../assets/icon/calendar.png'
import pnbLogo from "../../assets/pnb.jpeg"
// import ac from '../../assets/icon/ac.png'

import octiot from '../../assets/login/OCTIOT.png'
// One icon per chart type, for the chart headers.
import chartPower from '../../assets/icon/charts/power.svg'
import chartFrequency from '../../assets/icon/charts/frequency.svg'
import chartPowerFactor from '../../assets/icon/charts/powerFactor.svg'
import chartVoltage from '../../assets/icon/charts/voltage.svg'
import chartCurrent from '../../assets/icon/charts/current.svg'
import chartHumidity from '../../assets/icon/charts/humidity.svg'
import chartCo2 from '../../assets/icon/charts/co2.svg'
import chartAirQuality from '../../assets/icon/charts/airQuality.svg'
import chartControl from '../../assets/icon/charts/control.svg'
// The status tiles at the top of the dashboard.
import tileDeviceStatus from '../../assets/icon/charts/deviceStatus.svg'
import tileApplianceStatus from '../../assets/icon/charts/applianceStatus.svg'
import tileApplianceStatusOff from '../../assets/icon/charts/applianceStatusOff.svg'
import tileApplianceStatusOffline from '../../assets/icon/charts/applianceStatusOffline.svg'
import tileApplianceHealth from '../../assets/icon/charts/applianceHealth.svg'
let test = false
export const octiotUrl = test?"http://localhost:3000":"https://savings.octiotenergy.com" 

export const images = {
    powerConsumption,
    carbonFootPrint,
    temperature,
    onTime,
    voltage,
    powerFactor,
    deviceStatus,
    ac,
    unitConsumed,
    moneySaved,
    moneySpent,
    applianceHealth,
    savingPercantage,
    unit,
    coin,
    blub,
    ac,
    geyser,
    smartService,
    centerBanner,
    bottomBanner,
    octiot,
    doorClose,
    doorOpen,
    calendar,
    pnbLogo,
    chartPower,
    chartFrequency,
    chartPowerFactor,
    chartVoltage,
    chartCurrent,
    chartHumidity,
    chartCo2,
    chartAirQuality,
    chartControl,
    tileDeviceStatus,
    tileApplianceStatus,
    tileApplianceStatusOff,
    tileApplianceStatusOffline,
    tileApplianceHealth
}